/* ==========================================================================
   ty-branch-switch — מתג הסניפים. מעבדה 01.09.2026.

   🔴 החלת המצב הראשוני **אינה** כאן. היא בסקריפט inline קצר ב-
      layout/theme.liquid, שרץ ב-head לפני שהגוף מרונדר. בלעדיו המתג
      מהבהב: הוא מרונדר במצב הוד ואז קופץ לאילת. אותה הכרעה בדיוק
      שנרשמה על בורר הקבוצות בדף השעונים.

   🔴 המאזין תלוי ב-document ולא באלמנטים עצמם, כי facets.js דורס את
      innerHTML של #ProductGridContainer בכל סינון והמתג בהדר שורד,
      אבל בורר המעבדה עלול לשבת בתוך אזור שמרונדר מחדש.
   ========================================================================== */
(function () {
  'use strict';

  var KEY_BRANCH = 'ty_branch';

  function root() { return document.documentElement; }

  function readBranch() {
    return root().getAttribute('data-ty-branch-state') === 'eilat' ? 'eilat' : 'hod';
  }

  function paint(branch) {
    root().setAttribute('data-ty-branch-state', branch);
    document.querySelectorAll('[data-ty-branch]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-ty-branch') === branch));
    });
  }

  /* ══ המפה, הניווט, ומאפיין העגלה ═══════════════════════════════════
     🔴 המפה מוטמעת על ידי `ty-branch-swap`, שנבנה בשיחה האחורית.
        אם היא חסרה, המתג מחליף מראה בלבד ואינו מנווט. זה מכוון: הוא
        אינו שובר כלום לפני שהצד האחורי עלה.
     🔴 `MAP.prod` הוא **חד כיווני**, אילת ⟵ הוד, 187 רשומות. ההיפוך
        נבנה כאן בזיכרון, בדיוק כמו ב-ty-branch-swap.js. זה חוסך חצי
        מגודל המטא שדה, ולכן אין להוסיף לו את הכיוון השני.
     🔴 `MAP.col` **כן** דו כיווני, 88 רשומות, ולכן אוסף מתחלף בלי
        לבדוק כיוון.
     ⚠️ `MAP.both` הם אוספים שמכילים את שני הסניפים. שם **נשארים**,
        כי אין להם תאום ומעבר אליו היה מוביל ל-404. */

  var MAP = null, E2H = null, H2E = null;
  (function () {
    var el = document.getElementById("ty-branch-map");
    if (!el) return;
    try { MAP = JSON.parse(el.textContent); } catch (e) { MAP = null; return; }
    if (!MAP || !MAP.prod) { MAP = null; return; }
    E2H = MAP.prod;
    H2E = Object.create(null);
    for (var k in E2H) if (Object.prototype.hasOwnProperty.call(E2H, k)) H2E[E2H[k]] = k;
  })();

  /* הנתיב המקביל לדף הנוכחי, או null כשאין תאום ונשארים במקום */
  function twinPath(toBranch) {
    if (!MAP) return null;
    var col = MAP.col || {};
    var both = MAP.both || [];
    var hit = false;
    var out = location.pathname;

    out = out.replace(new RegExp("/collections/([^/?#]+)"), function (full, h) {
      var d; try { d = decodeURIComponent(h); } catch (e) { d = h; }
      if (both.indexOf(d) >= 0) return full;
      /* ty-col-dir >>> 14.10.2026: MAP.col דו כיווני, ולכן אוסף שכבר בסניף היעד
         הוחלף לתאום. במצב אילת על /collections/iphone, «מרכז» הוביל ל-iphone-eilat. */
      if ((d.indexOf("eilat") >= 0) === (toBranch === "eilat")) return full;
      /* <<< ty-col-dir */
      var t = col[d];
      if (!t) return full;
      hit = true;
      return "/collections/" + encodeURIComponent(t);
    });

    out = out.replace(new RegExp("/products/([^/?#]+)"), function (full, h) {
      var d; try { d = decodeURIComponent(h); } catch (e) { d = h; }
      var t = toBranch === "eilat" ? H2E[d] : E2H[d];
      if (!t) return full;
      hit = true;
      return "/products/" + encodeURIComponent(t);
    });

    return hit ? out + location.search : null;
  }

  /* 🔴 שליפה ואז שילוב, ולא כתיבה עיוורת. אותו דפוס כמו ty-branch-swap.js:
     מאפייני העגלה נשלפים, המפתח שלנו מתווסף, והכול נשלח בחזרה. */
  function writeCartBranch(branch) {
    /* ty-cart-nostore 14.10.2026: בחזרה אחורה הדפדפן הגיש /cart.js מהמטמון («כבר אילת»), הכתיבה דולגה,
       והדף הבא חזר למרכז בשקט. */
    return fetch("/cart.js", { cache: "no-store", headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : { attributes: {} }; })
      .catch(function () { return { attributes: {} }; })
      .then(function (cart) {
        var attrs = cart.attributes || {};
        if (attrs._ty_branch === branch) return null;
        attrs._ty_branch = branch;
        return fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ attributes: attrs })
        });
      })
      .catch(function () { return null; });
  }

  /* 🔴 כשמנווטים, הטוסט אינו יכול להיות מוצג לפני הניווט. הוא נשמר
     ב-sessionStorage ומוצג בטעינה הבאה. */
  var PENDING = "ty_branch_toast";

  /* 🔴 04.09.2026: הדף נשאר לחיץ בזמן המעבר, ולכן החסימה עברה
     לכאן. בלעדיה לחיצה כפולה על המתג משגרת שתי החלפות, ומאפיין
     העגלה נכתב פעמיים במרוץ. ה-CSS חוסם את המתג עצמו, וזה השער
     שסוגר גם מקלדת וגם משטח אחר שקורא לאותה פונקציה. */
  /* ty-clarity-branch >>> 14.10.2026, בקשת יובל: מדידה של הפופאפ והמתג ב-Clarity, שבוע, כדי להכריע
     אם הפופאפ מבריח לקוחות. אירועים: ty_gate_shown_auto|manual · ty_gate_pick_hod|eilat · ty_gate_autoclose ·
     ty_gate_dismiss · ty_switch_hod|eilat. תגית ty_branch בכל דף. clarity עלול לא להיות מוכן, ולכן תור עם ניסיון חוזר. */
  var clq = [], clT = null, clTries = 0;
  function clFlush() {
    clT = null;
    if (typeof window.clarity === "function") {
      while (clq.length) { var x = clq.shift(); try { window.clarity.apply(window, x); } catch (e) {} }
      return;
    }
    if (++clTries > 60) { clq = []; return; }
    clT = setTimeout(clFlush, 250);
  }
  function clr() { clq.push([].slice.call(arguments)); if (!clT) clFlush(); }
  /* <<< ty-clarity-branch */
  var switching = false;

  function setBranch(branch) {
    if (switching) return;
    if (branch !== "hod" && branch !== "eilat") return;
    var wasSame = readBranch() === branch;
    paint(branch);
    try { localStorage.setItem(KEY_BRANCH, branch); } catch (e) {}
    document.cookie = "ty_branch=" + branch + ";path=/;max-age=" + (60 * 60 * 24 * 180) + ";samesite=lax";

    /* 🔴 02.09.2026, בקשת יובל: בחירה בברירת המחדל אינה "מעבר".
       מי שבחר בפופאפ את הסניף שהוא כבר בו לא מקבל טוסט ולא רענון,
       רק כתיבה שקטה של מאפיין העגלה. */
    if (wasSame) {
      try { sessionStorage.removeItem(PENDING); } catch (e) {}
      writeCartBranch(branch);
      return;
    }

    clr("event", "ty_switch_" + branch); /* ty-clarity-branch */
    var nav = twinPath(branch);
    try { sessionStorage.setItem(PENDING, branch); } catch (e) {}

    /* עמעום קצר בזמן הכתיבה והניווט, כדי שהמעבר ייקרא כהחלפה אחת
       ולא כקפיצה. יורד מעצמו בדף הבא. */
    switching = true;
    root().setAttribute("data-ty-switching", "1");

    /* הכתיבה חייבת להסתיים לפני הניווט, אחרת הבקשה נקטעת ומאפיין
       העגלה נשאר על הערך הישן, והדף הבא מרונדר בסניף הלא נכון. */
    writeCartBranch(branch).then(function () {
      /* ניווט לאותה כתובת ולא reload, לעקביות עם מסלול התאום. */
      location.assign(nav || (location.pathname + location.search));
    });
  }
  /* חזרה מ-bfcache מחזירה את הדף עם העמעום. מנקים. */
  /* חזרה מ-bfcache מחזירה את הדף עם פס ההתקדמות. מנקים. */
  window.addEventListener("pageshow", function () {
    switching = false;
    root().removeAttribute("data-ty-switching");
  });

  /* ══ הפופאפ של הביקור הראשון ═══════════════════════════════════════
     🔴 02.09.2026, הכרעת יובל: הפופאפ ראשון, לפני באנר העוגיות.
        הבאנר מוסתר ב-CSS כל עוד data-ty-gate-shown על השורש, וחוזר
        מעצמו כשהפופאפ נסגר. ההסכמה אינה נחסמת, רק ממתינה תור. */

  var GATE_KEY = "ty_branch_gate_seen";


  /* 🔴 04.09.2026, הכרעת יובל: הפופאפ האוטומטי נעלם מעצמו
     אחרי שתי שניות, אם הלקוח לא בחר ולא נגע בו.

     🔴 חל על **הפתיחה האוטומטית בלבד**. פתיחה מהשבב או מ-#gate=1
        היא בקשה מפורשת של הלקוח, ושם חלון שנעלם מעצמו הוא באג.
        לכן openGate מקבל דגל, ולא נשען על משתנה גלובלי.

     🔴 מגע מבטל את הטיימר. בלי זה, הקשה שמתחילה על «אילת»
        ברגע שהחלון נעלם **אינה מגיעה לכפתור**: האלמנט מוסר בין
        touchstart ל-touchend, ולכן ה-click לעולם לא נורה. זו אינה
        העדפה, זו הקשה שהולכת לאיבוד.
     ⚠️ ‏`first.focus()` שלמטה הוא מיקוד תוכניתי, ולכן אין להקשיב
        ל-focusin: הוא היה מבטל את הטיימר מיד בפתיחה. */
  /* 🔴 חמש שניות, ולא שתיים. נמדד ולא נבחר: הכותרת ושני שמות
     הסניפים הם 11 מילים, כלומר 3.3 שניות לקורא ממוצע ו-4.1 לאיטי,
     ועוד 0.22 שניות של הנפשת הכניסה ועוד רגע של שימת לב.
     ⟹ בשתי שניות אפילו הקורא המהיר (2.5) אינו מספיק. */
  var GATE_AUTO_MS = 5000;
  var gateAutoT = null;
  function cancelGateAuto() { if (gateAutoT) { clearTimeout(gateAutoT); gateAutoT = null; } }

  function openGate(auto) {
    var g = document.getElementById("ty-gate");
    if (!g) return;
    g.removeAttribute("data-ty-fading");
    if (/gate=1/.test(location.hash || "")) {
      try {
        var h = location.hash.replace(/[#&]?gate=1/, "").replace(/^#?&/, "#");
        history.replaceState(null, "", location.pathname + location.search + (h === "#" ? "" : h));
      } catch (e) {}
    }
    g.hidden = false;
    /* סימון האפשרות הפעילה. כשהגיליון נפתח מהשבב הוא בורר ולא שאלה
       ראשונה, ובלי הסימון הלקוח לא רואה איפה הוא עומד. */
    var cur = readBranch();
    g.querySelectorAll("[data-ty-gate-choose]").forEach(function (x) {
      var on = x.getAttribute("data-ty-branch") === cur;
      x.setAttribute("aria-current", on ? "true" : "false");
    });
    document.documentElement.setAttribute("data-ty-gate-shown", "1");
    clr("event", auto ? "ty_gate_shown_auto" : "ty_gate_shown_manual"); /* ty-clarity-branch */
    var first = g.querySelector("[data-ty-gate-choose]");
    if (first) first.focus();

    cancelGateAuto();
    if (auto) {
      gateAutoT = setTimeout(function () {
        gateAutoT = null;
        if (document.documentElement.hasAttribute("data-ty-gate-shown")) { clr("event", "ty_gate_autoclose"); closeGate(true); } /* ty-clarity-branch */
      }, GATE_AUTO_MS);
    }
  }

  /* 🔴 הסגירה האוטומטית מסמנת «נראה», בדיוק כמו סגירה ידנית.
     בלי זה הפופאפ היה נפתח מחדש בכל מעבר עמוד, מהבהב שתי שניות
     ונעלם. ⚠️ המשמעות: לקוח שהתעלם שתי שניות לא יישאל שוב
     במכשיר הזה, ויישאר על ברירת המחדל «מרכז». הוצג ליובל. */
  function closeGate(fade) {
    var g = document.getElementById("ty-gate");
    if (!g) return;
    cancelGateAuto();
    var done = function () {
      g.hidden = true;
      g.removeAttribute("data-ty-fading");
      document.documentElement.removeAttribute("data-ty-gate-shown");
      try { localStorage.setItem(GATE_KEY, "1"); } catch (e) {}
    };
    if (!fade) { done(); return; }
    g.setAttribute("data-ty-fading", "1");
    setTimeout(done, 200);
  }

  /* מגע או מקלדת בתוך החלון = הלקוח מתעסק בו, והטיימר יורד. */
  document.addEventListener("pointerdown", function (e) {
    if (e.target && e.target.closest && e.target.closest(".ty-gate__box")) cancelGateAuto();
  }, true);
  document.addEventListener("keydown", function () {
    if (document.documentElement.hasAttribute("data-ty-gate-shown")) cancelGateAuto();
  }, true);

  /* 🔴 בדיקה רגעית של הבאנר אינה מספיקה, וזה נתפס בבקרה ולא בתיאוריה.
        באנר העוגיות של שופיפיי נשתל אסינכרונית, ולעתים **אחרי** ש-boot
        שלנו רץ. אז consentBannerOpen מחזיר false, הפופאפ נפתח, והבאנר
        צץ מעליו. בדיוק המצב שרצינו למנוע.
     ⟹ שתי הגנות, ושתיהן נדרשות:
        ① חלון המתנה של 1200 מילישניות לפני ההחלטה, שנותן לבאנר להישתל.
        ② מנטר שממשיך לרוץ אחרי הפתיחה. אם באנר צץ בכל זאת, הפופאפ
           נסגר, ממתין לו, ונפתח מחדש כשהוא נעלם. */

  var GATE_WATCH_MS = 20000;


  /* ══ מי רואה את הפופאפ בכלל ════════════════════════════════════════
     🔴 03.09.2026, הכרעת יובל: הפופאפ הוא ללקוח ש**נכנס לחנות**, ולא
        ללקוח שקיבל קישור. חבר ששלח קישור למוצר, או מודעה שמפנה למוצר
        ספציפי, לא אמורים להיפתח בשאלה על סניף.

     🔴 ההכרעה נעשית **פעם אחת בביקור, בדף הנחיתה**, ונשמרת ב-sessionStorage.
        ⟹ מי שנחת מקישור לא יראה את הפופאפ **גם אם יגלוש אחר כך לדף הבית**.
        הכרעת יובל באותו יום, מתוך שתי אפשרויות שהוצגו לו.

     שלושת הממדים, ורק שניים מהם ודאיים:
       ① דף הנחיתה   — נגזר בשרת (data-ty-home). מהימנות מלאה.
       ② פרמטר פרסום — gclid ודומיו בכתובת. מהימנות מלאה.
       ③ המקור       — document.referrer. טוב, לא מושלם.

     🔴 מודעה בגוגל מוסרת **בדיוק אותו referrer** כמו חיפוש אורגני. מה
        שמבדיל ביניהן הוא gclid בכתובת בלבד. בלי הסייג הזה כל המודעות
        היו מקבלות פופאפ, וזה בדיוק מה שיובל ביקש למנוע.
     📌 קישור מוואטסאפ אינו מוסר מקור כלל, וגם הקלדה ישירה אינה מוסרת.
        אבל הקלדה ישירה נוחתת ב**דף הבית**, ולכן הצירוף "אין מקור וגם
        דף עמוק" הוא כמעט תמיד קישור ששותף.
     ⚠️ #gate=1 עוקף הכול, וכך גם לחיצה על [data-ty-gate-open]. הבדיקה
        הזו חלה על הפתיחה האוטומטית בלבד. */

  var GATE_SESS = "ty_gate_landing_ok";
  var AD_PARAMS = /[?&](gclid|gbraid|wbraid|dclid|msclkid|fbclid|ttclid|twclid|li_fat_id|epik|irclickid|utm_source|utm_medium|utm_campaign)=/i;
  var SEARCH_HOSTS = /(^|\.)(google\.[a-z.]+|bing\.com|duckduckgo\.com|search\.yahoo\.[a-z.]+|yandex\.[a-z.]+|ecosia\.org|search\.brave\.com|startpage\.com|baidu\.com)$/i;

  function decideLanding() {
    var g = document.getElementById("ty-gate");
    /* דף הבית תמיד, מכל מקור שהוא */
    if (g && g.getAttribute("data-ty-home") === "1") return true;

    /* ty-gate-home-only 02.11.2026, יובל: החלון רק בדף הבית. בכל דף אחר הסניף נקבע מהדף, ומי שנכנס רואה את הסבר המתג. */
    return false;
  }

  function landingEligible() {
    var v = null;
    try { v = sessionStorage.getItem(GATE_SESS); } catch (e) {}
    if (v === "1" || v === "0") return v === "1";
    var ok = decideLanding();
    try { sessionStorage.setItem(GATE_SESS, ok ? "1" : "0"); } catch (e) {}
    return ok;
  }

  function gateReady() {
    var forced = /gate=1/.test(location.hash || "");
    var seen = false;
    /* ty-gate-seen >>> 08.10.2026, יובל: «כבר נשאל» = GATE_KEY בלבד. ty_branch שמור אינו בחירה: מאז 07.10 דף של אילת
       שומר אותו בעצמו (ty-page-branch), וכך מי שנחת באילת מגוגל דילג על החלון. כלל הנחיתה (landingEligible) לא השתנה. */
    try { seen = localStorage.getItem(GATE_KEY) === "1"; } catch (e) {}
    /* <<< ty-gate-seen */
    if (!forced && seen) return;
    if (!forced && !landingEligible()) return;
    if (forced) { try { localStorage.removeItem(GATE_KEY); } catch (e) {} }

    /* 🔴 02.09.2026, הכרעת יובל: הפופאפ מופיע לפני באנר העוגיות, לא
       אחריו. ההמתנה לבאנר והשומר שסגר את הפופאפ כשהבאנר צץ, בוטלו.
       הם ייצרו בדיוק את מה שיובל ראה: נפתח לשנייה, נעלם, וחזר אחרי
       אישור העוגיות. הסדר עכשיו: פופאפ ← בחירת סניף ← רענון ← באנר.
       הבאנר מוסתר בזמן שהפופאפ פתוח דרך CSS על data-ty-gate-shown,
       וחוזר מעצמו ברגע שהפופאפ נסגר. */
    /* 🔴 ‏gateReady משרת שני מסלולים, ורק אחד מהם אוטומטי.
       ‏#gate=1 היא בקשה מפורשת, ולכן היא **אינה** נסגרת מעצמה.
       נתפס בבדיקה: בגרסה הראשונה גם היא נעלמה אחרי שתי שניות. */
    /* >>> ty-gate-pending (17.09.2026) */
    /* הבאנר מוסתר כבר עכשיו, ולא 350ms אחר כך כשהפופאפ נפתח. בפער הזה הבאנר
       הוצג, ולחיצה על «מסכים» נחתה על הרקע של הפופאפ וסגרה אותו במקום לאשר.
       נמדד 17.09.2026: ‏17 מתוך 20. ההסבר: apply-consent-accept-fix-2026-09-17.mjs */
    document.documentElement.setAttribute("data-ty-gate-pending", "1");
    setTimeout(function () {
      openGate(!forced);
      document.documentElement.removeAttribute("data-ty-gate-pending");
    }, 350);
    /* <<< ty-gate-pending */
  }

  /* ══ טוסט אחרי החלפה ישירה ═════════════════════════════════════════
     🔴 בפריסה המרכזית הלחיצה מחליפה מיד ואינה פותחת את הגיליון, ולכן
        הלקוח אינו רואה ש«אילת» היא איסוף בלבד. הטוסט מחזיר את המשמעות
        בלי לחסום את המעבר. */
  var toastEl = null, toastT = null;
  function toast(branch) {
    if (!toastEl) {
      toastEl = document.createElement("div");
      toastEl.className = "ty-toast";
      toastEl.setAttribute("role", "status");
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = branch === "eilat"
      ? "שים לב! עברת לחנות אילת"
      : "שים לב! עברת לחנות מרכז";
    toastEl.setAttribute("data-on", "1");
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.setAttribute("data-on", "0"); }, 3400);
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-ty-branch-toggle]")) {
      var next = readBranch() === "eilat" ? "hod" : "eilat";
      try { localStorage.setItem(GATE_KEY, "1"); } catch (e2) {} /* ty-gate-seen: לחיצה על המתג היא בחירה */
      /* 🔴 04.09.2026, הכרעת יובל: ההודעה מוצגת **כבר בזמן המעבר**,
         כדי שהלקוח יראה שמשהו קורה בזמן שהדף נטען. לכן הקריאה כאן
         נשארת, והיא רצה על הדף **הישן**.
         ⚠️ ההכרעה הראשונה באותו יום הייתה הפוכה, "רק אחרי המעבר",
         והיא בוטלה לפני שעלתה לחי. מה שהפריע היה שההודעה נראתה
         **דהויה**, ולא שהיא הופיעה מוקדם.
         ⟹ התיקון עבר ל-CSS: העמעום הוא וילון נפרד ולא opacity על
         הגוף, ולכן ההודעה נשארת בעוצמה מלאה מעליו.
         🔴 setBranch שומר אותה גם ב-sessionStorage, ו-flushToast
         מציג אותה שוב בדף החדש. הרצף הזה מכוון.
 */
      setBranch(next);
      toast(next);
      return;
    }
    if (e.target.closest("[data-ty-gate-open]")) { openGate(); return; }
    if (e.target.closest("[data-ty-gate-dismiss]")) { clr("event", "ty_gate_dismiss"); closeGate(); return; } /* ty-clarity-branch */
    var pick = e.target.closest("[data-ty-gate-choose]");
    if (pick) {
      clr("event", "ty_gate_pick_" + pick.getAttribute("data-ty-branch")); /* ty-clarity-branch */
      closeGate();
      /* 🔴 הבחירה בפופאפ היא מה שכותב את _ty_branch בפעם הראשונה, וכל
         מה שאחריו נשען עליו. setBranch עושה גם את הכתיבה וגם את הניווט. */
      setBranch(pick.getAttribute("data-ty-branch"));
    }
  });
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && document.documentElement.hasAttribute("data-ty-gate-shown")) { clr("event", "ty_gate_dismiss"); closeGate(); } /* ty-clarity-branch */
  });

  /* טוסט שנשמר לפני ניווט, מוצג בטעינה שאחריו */
  function flushToast() {
    var v = null;
    try { v = sessionStorage.getItem(PENDING); sessionStorage.removeItem(PENDING); } catch (e) {}
    /* 🔴 06.09.2026, הכרעת יובל: «שההודעה תופיע רק בטעינה, וכשנגמרה
       הטעינה ההודעה תפסיק להופיע».
       ⟹ הקריאה ל-toast כאן הוסרה. ההודעה מוצגת על הדף **הישן** בזמן
       הניווט (ראה toast(next) בטיפול בלחיצה), ואינה חוזרת בדף החדש.
       ⚠️ המפתח עדיין נקרא ונמחק למעלה, אחרת הוא נשאר בישיבה ומצטבר.
       🔙 להחזרה: להחזיר את השורה  if (v === "hod" || v === "eilat") toast(v); */
    void v;
  }

  /* ══ תרגום קישורי אוסף לפי הסניף (02.09.2026, דרישת יובל להשקה) ═══
     התפריטים אינם משוכפלים לאילת בכוונה (תפריט כפול נסחף), ולכן
     הקישורים מתורגמים כאן, דרך אותה מפה שהמתג כבר טוען.

     🔴 MAP.col דו-כיווני (88 רשומות = 44 זוגות), ולכן חובה שער כיוון:
        בלעדיו קישור שכבר מצביע לאילת היה מתורגם בחזרה להוד.
        צד הקישור נקבע לפי 'eilat' ב-handle. נמדד: כל 44 אוספי
        אילת מכילים אותו, כולל בעלי השם העברי.
     ⚠️ MAP.both (אוספים דו-סניפיים) נשארים כמו שהם, כמו ב-twinPath.
     📌 מעבר סטטי בטעינה + תפיסת קליק. הקליק תופס תוכן שרונדר מאוחר,
        למשל מסננים שמחליפים את ה-DOM דרך facets.js. */
  function collHref(a, branch) {
    if (!MAP || !MAP.col) return null;
    /* 🔴 הברדקראמב מוחרג מהתרגום, בכוונה. הוא מתאר איפה המוצר **הזה**
       יושב, ולא לאן הלקוח רוצה ללכת, ולכן הוא אינו תלוי-סניף.
       ⚠️ בלי ההחרגה הכיתוב והיעד סותרים זה את זה: בדף מוצר אילת נכתב
       «iPhone באילת» והקישור נוחת על אוסף ההוד. נמדד 03.09.2026 בערכת
       מעבדה, ובשני מצבי הסניף, ולכן זה אינו מקרה קצה של מצב לא מסונכרן.
       📌 ליקוויד נתן /collections/iphone-eilat תקין לחלוטין. השכתוב קרה
       כאן, בדפדפן, אחרי הרינדור. זו הסיבה שבדיקת ליקוויד לבדה לא תפסה. */
    if (a.closest && a.closest(".breadcrumbs, .ty-eilat-links")) return null;
    try {
      var url = new URL(a.getAttribute("href"), location.origin);
      if (url.origin !== location.origin) return null;
      var m = url.pathname.match(/^\/collections\/([^\/]+)\/?$/);
      if (!m) return null;
      var h; try { h = decodeURIComponent(m[1]); } catch (e) { h = m[1]; }
      if ((MAP.both || []).indexOf(h) >= 0) return null;
      /* ty-own-coll >>> 07.10.2026
         🔴 קישור לאוסף של הדף עצמו (הצג עוד, עימוד, מיון) אינו מתורגם.
            עד היום «הצג עוד» ב-iphone-eilat במצב מרכז הוסיף 11 מוצרי הוד. */
      var own = location.pathname.match(/^\/collections\/([^\/]+)/);
      if (own) { var oh; try { oh = decodeURIComponent(own[1]); } catch (e) { oh = own[1]; }
        if (oh === h) return null; }
      /* <<< ty-own-coll */
      var linkIsEilat = h.indexOf("eilat") >= 0;
      if (branch === "eilat" ? linkIsEilat : !linkIsEilat) return null;
      var t = MAP.col[h];
      if (!t) return null;
      return "/collections/" + encodeURIComponent(t) + url.search + url.hash;
    } catch (e) { return null; }
  }
  function translateLinks() {
    var branch = readBranch();
    var links = document.querySelectorAll('a[href*="/collections/"]');
    for (var i = 0; i < links.length; i++) {
      var nu = collHref(links[i], branch);
      if (nu) links[i].setAttribute("href", nu);
    }
  }
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest('a[href*="/collections/"]');
    if (!a) return;
    var nu = collHref(a, readBranch());
    if (nu) a.setAttribute("href", nu);
  }, true);

  /* 🔴 הסניף שהגיע מהכתובת (?branch=eilat) נקבע כבר ב-head, לפני
     הציור הראשון. כאן משלימים את מה שאי אפשר לעשות שם:
       ① מאפיין העגלה, שהוא המצב שהשרת רואה בקופה.
       ② ניקוי הפרמטר מהכתובת, כדי שהוא לא ידבק בשיתוף הבא.
     ⚠️ הניקוי ב-replaceState ולא בניווט, אחרת הדף נטען פעמיים. */
  function absorbBranchParam() {
    /* 🔴 גבול המילה נכתב כ-(?:&|$) ולא כרצף לוכסן-b. הלוכסן נבלע
       בשרשרת הכתיבה והפך ל**תו backspace אמיתי**, והרגקס לא התאים
       לעולם. נתפס במדידה: המנגנון היה בחנות ולא עבד, בלי שום שגיאה. */
    var m = (location.search || "").match(/[?&]branch=(eilat|hod)(?:&|$)/i);
    if (!m) return;
    writeCartBranch(m[1].toLowerCase());
    try {
      var s = location.search.replace(/([?&])branch=(eilat|hod)(?:&|$)/i, "$1").replace(/[?&]$/, "");
      history.replaceState(null, "", location.pathname + s + location.hash);
    } catch (e) {}
  }


  /* ty-menu-prod >>> 01.10.2026
     🔴 התפריט העליון מקשר לדגמים בדף מוצר, ו-collHref מתרגם רק אוספים. בלי זה
        לקוח שבחר אילת ולחץ על דגם בתפריט נחת על דף ההוד, עם מע"מ ומשלוח.
     📌 המפה כבר כאן (MAP.prod, 193 זוגות), ולכן אין צורך באוסף לכל דגם.
     🔴 בתוך header בלבד, בכוונה. בכרטיסי מוצר בשאר החנות קישור לאילת או להוד
        הוא החלטה של הכרטיס (כפתור «שריון באילת»), ותרגום שם היה שובר אותה. */
  function menuProdHref(a, branch) {
    if (!MAP || !a.closest || !a.closest("header")) return null;
    try {
      var url = new URL(a.getAttribute("href"), location.origin);
      if (url.origin !== location.origin) return null;
      var m = url.pathname.match(/^\/products\/([^\/?#]+)\/?$/);
      if (!m) return null;
      var h; try { h = decodeURIComponent(m[1]); } catch (e) { h = m[1]; }
      var t = branch === "eilat" ? H2E[h] : E2H[h];
      if (!t) return null;
      return "/products/" + encodeURIComponent(t) + url.search + url.hash;
    } catch (e) { return null; }
  }
  function translateMenuProducts() {
    var branch = readBranch();
    var links = document.querySelectorAll('header a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) {
      var nu = menuProdHref(links[i], branch);
      if (nu) links[i].setAttribute("href", nu);
    }
  }
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;
    var a = e.target.closest('header a[href*="/products/"]');
    if (!a) return;
    var nu = menuProdHref(a, readBranch());
    if (nu) a.setAttribute("href", nu);
  }, true);
  /* <<< ty-menu-prod */

  function boot() {
    paint(readBranch()); clr("set", "ty_branch", readBranch()); /* ty-clarity-branch */ absorbBranchParam(); gateReady(); flushToast();
    /* ty-page-branch: דף אילת קבע את הסניף ב-head. כאן נכתב מאפיין העגלה,
       כדי שהדף הבא והקופה יהיו באותו סניף. */
    if (root().getAttribute("data-ty-page-branch") === "eilat") writeCartBranch("eilat");
    translateLinks(); translateMenuProducts();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
